import CartIcon from 'asset/baga/cart-icon.svg'
import { Button } from 'component/Button/Button'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import css from './ComboCartIndicatorBaga.module.scss'

interface ComboCartIndicatorProps {
  onOpen?: () => void
}

export const ComboCartIndicatorBaga = observer(({ onOpen }: ComboCartIndicatorProps) => {
    const onClick = useLatestCallback(() => {
      if (onOpen) onOpen()
    })

    return <Button className={css.button} xl action={onClick}>
      <CartIcon />
      {comboCartStore.count}
    </Button>
  },
)
